import { Controller } from "@hotwired/stimulus"

// SEM: the dashboard "copy" affordance — copies the text of a named on-page element
// (the raw token, or an MCP connect command) to the clipboard and briefly confirms on
// the button. HAS-A `source` value naming the element id it reads. USED-BY the copy
// buttons via `data-action="click->copy#copy"`. It does not own the token or command
// text — it mirrors what the page already shows.
//
// It lives in a bundled controller (CSP `script-src 'self'`) and Stimulus re-binds it on
// every Turbo render, including a cache-restore visit — so copy survives navigation. The
// prior inline-script binding carried a per-response CSP nonce that went stale on a Turbo
// restore and was blocked, leaving the buttons dead.
export default class extends Controller {
  static values = { source: String }

  copy() {
    const source = document.getElementById(this.sourceValue)
    if (!source) return

    navigator.clipboard.writeText(source.textContent)

    const original = this.element.textContent
    this.element.textContent = "copied"
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => { this.element.textContent = original }, 1500)
  }
}
